import { render } from "./FeedbackConfirmation.vue?vue&type=template&id=4029f540"
import script from "./FeedbackConfirmation.vue?vue&type=script&lang=js"
export * from "./FeedbackConfirmation.vue?vue&type=script&lang=js"

import "./FeedbackConfirmation.vue?vue&type=style&index=0&id=4029f540&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__